import { estiloColores } from "./colores";

export const BarraSuperior = {
  Modal: {
    backgroundColor: estiloColores.Azul,
    color: estiloColores.Blanco,
    borderRadius: "0px",
  },

  Pasajero: {
    backgroundColor: estiloColores.Rojo,
    color: estiloColores.Blanco,
    borderRadius: "0px",
  },

  Conductor: {
    backgroundColor: estiloColores.Rojo,
    color: estiloColores.Blanco,
    borderRadius: "0px",
  },

  Administrador: {
    backgroundColor: estiloColores.Rojo,
    color: estiloColores.Blanco,
    borderRadius: "0px",
  },
};
